import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  List,
  ListItem,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import isEqual from "lodash/isEqual";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";

const DateRangePicker = ({ onApply }) => {
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  const yesterday = new Date(
    new Date(new Date().setDate(today.getDate() - 1)).setHours(0, 0, 0, 0)
  );
  const maxDate = new Date(new Date().setHours(23, 59, 59, 999));

  const DATA_RANGE_TYPES = [
    {
      title: "Today",
      alias: "today",
      period: {
        since: today,
        until: today,
      },
    },
    {
      title: "Yesterday",
      alias: "yesterday",
      period: {
        since: yesterday,
        until: yesterday,
      },
    },
    {
      title: "Last 7 days",
      alias: "last7days",
      period: {
        since: new Date(
          new Date(new Date().setDate(today.getDate() - 7)).setHours(0, 0, 0, 0)
        ),
        until: yesterday,
      },
    },
  ];

  const [activeDateRange, setActiveDateRange] = useState(DATA_RANGE_TYPES[0]);
  const [oldDateRange, setOldDateRange] = useState(DATA_RANGE_TYPES[0]);
  const [popoverActive, setPopoverActive] = useState(false);
  const [inputValues, setInputValues] = useState({
    since: today,
    until: new Date(),
  });

  const apply = () => {
    if (typeof onApply === "function") {
      const { since: from, until: to } = inputValues;
      onApply("date", {
        from: new Date(new Date(from).setHours(0, 0, 0, 0)).toISOString(),
        to: new Date(new Date(to).setHours(23, 59, 59, 999)).toISOString(),
      });
    }
    setOldDateRange(activeDateRange);
    setUnsavedChanges(false);
    setPopoverActive(false);
  };

  const cancel = () => {
    setActiveDateRange(oldDateRange);
    setPopoverActive(false);
  };

  const onChange = (dates) => {
    const [start, end] = dates;
    console.log("dates", dates);
    const newDateRange = {
      alias: "custom",
      title: "Custom",
      period: {
        since: start,
        until: end,
      },
    };
    setActiveDateRange(newDateRange);
  };

  useEffect(() => {
    console.log("activeDateRange", activeDateRange);
    if (!isEqual(oldDateRange, activeDateRange)) {
      setUnsavedChanges(true);
    } else {
      setUnsavedChanges(false);
    }
    setInputValues({
      since: activeDateRange?.period?.since,
      until: activeDateRange?.period?.until,
    });
  }, [activeDateRange]);

  return (
    <FormControl display="flex" alignItems="center">
      <FormLabel htmlFor="date" mb="0">
        Choose Date:
      </FormLabel>
      <Popover isOpen={popoverActive} onClose={() => setPopoverActive(false)}>
        <PopoverTrigger>
          <Button
            onClick={() => {
              setPopoverActive(!popoverActive);
            }}
          >
            {activeDateRange?.title}
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody>
            <Flex justifyContent={"flex-start"}>
              <Box>
                <br />
                <List spacing={3}>
                  {DATA_RANGE_TYPES.map((dateType, index) => {
                    return (
                      <ListItem
                        key={index}
                        className={
                          activeDateRange.alias === dateType.alias
                            ? "selected"
                            : ""
                        }
                        style={{
                          ...(activeDateRange?.alias === dateType?.alias
                            ? { background: "#8080804d" }
                            : {}),
                          padding: "10px",
                        }}
                        onClick={() => {
                          setActiveDateRange(dateType);
                        }}
                      >
                        {dateType?.title}
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
              <Box>
                <br />

                <Flex justifyContent="flex-start">
                  <Box p={4}>
                    <DatePicker
                      selected={inputValues?.since}
                      onChange={onChange}
                      startDate={inputValues?.since}
                      endDate={inputValues?.until}
                      selectsRange
                      inline
                      maxDate={maxDate}
                    />
                  </Box>
                </Flex>
              </Box>
            </Flex>
            {unsavedChanges ? (
              <Flex justifyContent={"flex-end"}>
                <Button mr={"20px"} colorScheme={"yellow"} onClick={cancel}>
                  Cancel
                </Button>
                <Button colorScheme={"red"} onClick={apply}>
                  Apply
                </Button>
              </Flex>
            ) : (
              <></>
            )}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </FormControl>
  );
};

export default DateRangePicker;
